import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { equationStringToSimplifiedParsedString } from '~/bootcamp/Activities/Algebra/Algebra.utils'

const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['a', 'b', 'c', 'd', 'y', 'z'],
    maxHistoryLength: 10,
  },
  2: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['ab', 'by', 'cz', 'az', 'bx', 'yz'],
    maxHistoryLength: 10,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  minCoefficient: number
  maxCoefficient: number
  variables: string[]
  maxHistoryLength: number
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ActivityDataModel {
  coefficientString: string
  equationCoefficients: number[]
  variable: string
  coefficientTotal: number
  maxHistoryLength: number
}

/**
 * generates data related to activity
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns activity data
 */
export function generateVariableAddActivityData(difficultyLevel: number, taskHistory: string[]): ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const totalTerms = getRandomInt(range.minTerms, range.maxTerms)
  const equationCoefficients: number[] = []
  const variable = range.variables[getRandomInt(0, range.variables.length - 1)]
  let coefficientTotal = 0
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms; i++) {
    const temp = getRandomInt(range.minCoefficient, range.maxCoefficient)
    equationCoefficients[i] = temp
    coefficientTotal += temp
  }

  let coefficientString = variable
  equationCoefficients.forEach((item) => {
    coefficientString += `-${item}`
  })

  if (taskHistory.includes(coefficientString)) return generateVariableAddActivityData(difficultyLevel, taskHistory)

  return {
    coefficientString,
    equationCoefficients,
    variable,
    coefficientTotal,
    maxHistoryLength: range.maxHistoryLength,
  }
}

/**
 * checks the answer
 * @param answer user given answer
 * @param coefficientTotal expected coefficient
 * @param variable expected variable
 * @returns if the answer is right
 */
export function checkVariableAddAnswer(answer: string, coefficientTotal: number, variable: string): boolean {
  return (
    equationStringToSimplifiedParsedString(coefficientTotal + variable) ===
    equationStringToSimplifiedParsedString(answer)
  )
}
